import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ShieldCheck } from 'lucide-react';
export function RevelationSection() {
  return <section className="bg-emerald-mid text-white py-12 md:py-16 px-4 relative overflow-hidden" data-id="element-82">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-light rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-83"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-deep rounded-full blur-3xl opacity-40 translate-y-1/2 -translate-x-1/2" data-id="element-84"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-emerald-dark/40 border border-emerald-light/30 rounded-2xl p-6 md:p-10 backdrop-blur-sm" data-id="element-86">
          <div className="flex items-center justify-center mb-6" data-id="element-87">
            <AlertTriangle className="w-10 h-10 md:w-12 md:h-12 text-gold mr-4" data-id="element-88" />
            <h2 className="text-2xl md:text-4xl font-display font-bold text-gold" data-id="element-89">
              El Enemigo Oculto en tu Supermercado
            </h2>
          </div>

          <p className="text-base md:text-xl text-warm-white/90 font-body leading-relaxed mb-8 text-center" data-id="element-90">
            La industria nos vende productos "fit" llenos de aditivos que rompen
            tu barrera intestinal.{' '}
            <strong className="text-white" data-id="element-91">
              Estás intentando sanar con los mismos ingredientes que te
              inflaman.
            </strong>
          </p>

          <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/30 to-transparent my-6 md:my-8" data-id="element-92"></div>

          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-93">
            <div className="bg-emerald-light/20 p-4 rounded-full flex-shrink-0" data-id="element-94">
              <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-gold-light" data-id="element-95" />
            </div>
            <p className="text-base md:text-lg text-warm-white font-body leading-relaxed text-center md:text-left" data-id="element-96">
              El Reinicio Biológico identifica estos saboteadores y sella tu
              sistema digestivo desde la raíz. Es el{' '}
              <strong className="text-gold" data-id="element-97">"botón de reset"</strong> que tu
              metabolismo pide a gritos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}